import { GET_ENROLLS } from "./types"
import apiStore from "../store/ApiStore";

export const getEnrolls = (start = null, end = null, page = 0, pagesize = 10, search = null, result = null, orderBy = null, orderDesc = null) => {
    return {
        type: GET_ENROLLS,
        items: apiStore.getVoiceEnrollAll(start, end, page < 0 ? 0 : page, pagesize, search, result, orderBy, orderDesc),
    }
}
